import React, { useState } from 'react';

function UploadTripData({ onUpload }) {
  const [inputKey, setInputKey] = useState(Date.now());

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/json") {
      const reader = new FileReader();
      setInputKey(Date.now());
      reader.onload = (e) => {
        const data = JSON.parse(e.target.result);
        onUpload(data);  // Pass the data up to the parent component
      };
      reader.readAsText(file);
    } else {
      alert('Please upload a valid JSON file.');
    }
  };


  return (
    <div>
      <h1>Upload Trip Data JSON File</h1>
      <input
        type="file"
        key={inputKey}
        onChange={handleFileChange}
        style={{ display: 'block', margin: '20px 0' }}
      />
    </div>
  );
}

export default UploadTripData;
